<template>
  <div>
    Project not found. Please check your web address and try again.
  </div>
</template>

<script>
export default {
  name: 'ProjectNotFound'
}
</script>
